(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/react/pages/rules/rules.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/react/pages/rules/rules.js');

'use strict';

const _svs$termsIntegrity$s = svs.termsIntegrity.sharedComponents,
  Footer = _svs$termsIntegrity$s.Footer,
  MainPage = _svs$termsIntegrity$s.MainPage,
  TopMenu = _svs$termsIntegrity$s.TopMenu;
const useGetCmsDataFolder = svs.termsIntegrity.sharedComponents.useGetCmsDataFolder;
const DocList = svs.termsIntegrity.sharedComponents.DocList;
const Rules = () => {
  const rulesFolderId = ReactRedux.useSelector(state => state.termsIntegrity.rulesFolderId);
  const _useGetCmsDataFolder = useGetCmsDataFolder(rulesFolderId),
    docData = _useGetCmsDataFolder.data,
    docLoading = _useGetCmsDataFolder.loading,
    docDataError = _useGetCmsDataFolder.dataError;
  return React.createElement(React.Fragment, null, React.createElement(TopMenu, null), React.createElement(MainPage, null, React.createElement("h2", null, "Spelregler"), React.createElement("div", {
    className: "margin-xs-top-1"
  }, docDataError && React.createElement("div", null, "Fel vid h\xE4mtning av dokument"), docLoading && React.createElement("div", null, "Laddar dokument..."), docData && docData.length > 0 && React.createElement(DocList, {
    docList: docData
  }))), React.createElement(Footer, null));
};
svs.termsIntegrity.rules.Rules = Rules;

 })(window);